/**
 * no example message ATM
 * @param {*} pluginTemplate
 * @returns object with fields:
 * 1) open
 * 2) prevClose
 */
export function gapFilterParser(pluginTemplate) {
  const parsedObject = {
    open: null,
    prevClose: null,
  };
  if (pluginTemplate) {
    parsedObject.open = pluginTemplate.open;
    parsedObject.prevClose = pluginTemplate.prevClose;
  }
  return parsedObject;
}
